import React from "react";
import { Navigate } from "react-router-dom";
import SignUp from "src/components/accout/SignUp";
import { selectIsAuth } from "src/store/authSlice";
import { useSelector } from "src/store/Store";

function SignUpPage() {
  const isAuthenticated = useSelector(selectIsAuth);

  if (isAuthenticated) return <Navigate to={"/"} />;

  return <SignUp />;
}

export default SignUpPage;
